import { AB_CONFIG_KEYS } from "../../constants/AbConfigKeys";
import {AB_CONFIG_SET} from "../../constants/ActionTypes";

const initialState = {
  ...AB_CONFIG_KEYS,
};

export default function(state = initialState, action) {
  if (action.type === AB_CONFIG_SET) {
    return {
      ...state,
      ...action.payload.data,
    }
  }
  return state;
}
